import { Bell } from "lucide-react";
import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";

/**
 * Top-right Messages bell → Inbox. Badge = shell notif count (plan/50).
 */
export function DeskBellButton(props: {
  companySlug: string;
  count: number;
  className?: string;
}) {
  const n = Math.max(0, Math.floor(props.count));
  const badge = n > 99 ? "99+" : n > 0 ? String(n) : null;
  const label =
    n > 0 ? `Messages and needs me (${badge})` : "Messages — Inbox";

  return (
    <Link
      to={`/c/${props.companySlug}/inbox`}
      className={cn(
        "relative inline-flex size-9 items-center justify-center rounded-md text-[var(--color-muted)] no-underline transition-colors hover:bg-[var(--color-border)]/35 hover:text-[var(--color-foreground)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--color-ring)]",
        props.className,
      )}
      aria-label={label}
      title={label}
    >
      <Bell className="size-[1.125rem]" aria-hidden />
      {badge ? (
        <span
          className="absolute -right-0.5 -top-0.5 flex h-4 min-w-4 items-center justify-center rounded-full bg-[var(--color-primary)] px-1 text-[9px] font-semibold leading-none text-[var(--color-primary-fg)]"
          aria-hidden
        >
          {badge}
        </span>
      ) : null}
    </Link>
  );
}
